import moment from "moment";
import {
  MOBILE_ORIGINATED_LOADING,
  SET_MO_COUNTS,
  RESET_REPORTS,
  ADD_MOBILE_ORIGINATED_ERROR,
} from "../constants";
import { MO_SESSION_TOKEN } from "../actions/mobileOriginatedActions";

let SAVED_STATE = JSON.parse(sessionStorage.getItem(MO_SESSION_TOKEN));
if (SAVED_STATE && moment().isAfter(SAVED_STATE.expires_at)) {
  SAVED_STATE = null;
}

const initial_state = {
  errors: {},
  loading: {},

  // User selected options
  options: {
    startDateTime: moment().subtract(1, "day").startOf("day"), // Default: start of yesterday
    endDateTime: moment().endOf("day"), // Default: through today
    expires_at: moment().add(1, "hour").toJSON(),
    ...SAVED_STATE,
  },

  // Display Data based on selections above
  counts: [
    /* {type_vch: String, subtype_vch: String, count: Number}, ... */
  ],
};

export default function (state = initial_state, { type, payload, name }) {
  let { loading, errors } = state;

  switch (type) {
    case MOBILE_ORIGINATED_LOADING:
      loading[payload] = true;

      return {
        ...state,
        loading: { ...loading },
      };

    case ADD_MOBILE_ORIGINATED_ERROR:
      // If provided, clear loading
      name && (loading[name] = false);

      if (payload.message) {
        payload = {
          [name]: "There was a problem. Please try again later",
        };
      }

      errors = {
        ...errors,
        ...payload,
      };
      return {
        ...state,
        errors,
        loading: { ...loading },
      };

    case SET_MO_COUNTS:
      loading["counts"] = false;
      delete errors["counts"]; // clear previous errors

      return {
        ...state,
        loading: { ...loading },
        errors: { ...errors },
        counts: payload || [],
      };

    case RESET_REPORTS:
      return { ...initial_state };

    default:
      return state;
  }
}
